import { ImageArray } from '@av/utils';
import { ShopMeta } from '../types';

export const getMainConversionsFromProduct = (shopMeta: ShopMeta) => {
  const images = shopMeta.files?.images?.length
    ? shopMeta.files.images.find((i) => i.is_main) || shopMeta.files.images[0]
    : undefined;

  return (
    images?.conversions ||
    shopMeta.images ||
    ((shopMeta.image_url
      ? ['800', '640', '320', '160'].map((type) => ({ type, url: shopMeta.image_url || '' }))
      : []) as ImageArray)
  );
};
